/** Auto-generated — niet handmatig wijzigen. Bron: ops/write-frontend-build-info.sh */
import { BuildHistoryEntry } from './build-history';

export const BUILD_BRANCH = 'main';
export const BUILD_SHA = '4fb70306';
/** PR-nummer voor korte footer-label (PR#N), of null. */
export const BUILD_PR: number | null = 1104;

/** Laatste 10 first-parent commits (PR-merges op de deploy-branch). */
export const BUILD_HISTORY: BuildHistoryEntry[] = [
  {
    sha: '4fb70306',
    pr: 1104,
    title: 'Release: clubalbums samenvoegen, menu inklappen, klok, statusregel en rustige kopregel (#1104-#1108) naar live (#1109)',
    author: 'provispo',
    date: '2026-11-03T21:13:09+01:00',
    subject: 'Release: clubalbums samenvoegen, menu inklappen, klok, statusregel en rustige kopregel (#1104-#1108) naar live (#1109)',
    stats: '46 files changed, 1223 insertions(+), 265 deletions(-)',
  },
  {
    sha: '600cc413',
    pr: 1099,
    title: '- #1099 Live: knop Quality voor de kwaliteit van het cloudbeeld (optie C)',
    author: 'provispo',
    date: '2026-11-03T17:45:36+01:00',
    subject: 'Release: Quality-knop, zijbalk met logo, veld bij opname, clubalbums weg, Local/Cloud (#1099-#1103) naar live (#1105)',
    stats: '41 files changed, 891 insertions(+), 63 deletions(-)',
  },
  {
    sha: 'bd0e4d0f',
    pr: 1095,
    title: 'Claude-Session: https://claude.ai/code/session_01455gKgkxZG5YXuXjpjUoqD',
    author: 'provispo',
    date: '2026-11-03T14:56:20+01:00',
    subject: 'Release: Integrations Incoming/Outgoing, studiopas via Open als club, clublogo op Live (#1095-#1097) naar live (#1098)',
    stats: '20 files changed, 136 insertions(+), 36 deletions(-)',
  },
  {
    sha: 'f94c1477',
    pr: 1087,
    title: 'Claude-Session: https://claude.ai/code/session_01455gKgkxZG5YXuXjpjUoqD',
    author: 'provispo',
    date: '2026-11-03T14:07:08+01:00',
    subject: 'Release: R&D-iconen en testdag VV Terneuzen (#1087-#1093) naar live (#1094)',
    stats: '44 files changed, 692 insertions(+), 122 deletions(-)',
  },
  {
    sha: '8ec3fea9',
    pr: 1085,
    title: 'Claude-Session: https://claude.ai/code/session_01455gKgkxZG5YXuXjpjUoqD',
    author: 'provispo',
    date: '2026-11-03T11:20:50+01:00',
    subject: 'Release: videolink Alsadd/Alarab herkennen (#1085) naar live (#1086)',
    stats: '3 files changed, 26 insertions(+), 2 deletions(-)',
  },
  {
    sha: 'aa53ff8c',
    pr: 1084,
    title: 'Sinds release #1076:',
    author: 'provispo',
    date: '2026-11-03T09:59:13+01:00',
    subject: 'Release 03-11-2026: dev naar main (#1084)',
    stats: '51 files changed, 1353 insertions(+), 67 deletions(-)',
  },
  {
    sha: 'af2beef0',
    pr: 1076,
    title: 'Inhoud gelijk aan dev (#1052-#1075), op main gezet als één release.',
    author: 'provispo',
    date: '2026-11-02T20:26:42+01:00',
    subject: 'Release 02-11: taggen zonder internet, noodbediening, instellingen van de studio-pc op afstand (#1076)',
    stats: '124 files changed, 3649 insertions(+), 420 deletions(-)',
  },
  {
    sha: '8ae8cff4',
    pr: 1051,
    title: 'Release 01-11: nieuwe Live-pagina, Usage voor de club, studio en PlayStats samen (achter schakelaar), Partners & API (#1051)',
    author: 'provispo',
    date: '2026-11-01T22:45:42+01:00',
    subject: 'Release 01-11: nieuwe Live-pagina, Usage voor de club, studio en PlayStats samen (achter schakelaar), Partners & API (#1051)',
    stats: '305 files changed, 34845 insertions(+), 1640 deletions(-)',
  },
  {
    sha: 'c7c45e1e',
    pr: 1032,
    title: 'Event zonder gebruiker toegestaan: tags van een studio-pc op apparaat-token (#1032) (#1036)',
    author: 'provispo',
    date: '2026-11-01T15:02:12+01:00',
    subject: 'Event zonder gebruiker toegestaan: tags van een studio-pc op apparaat-token (#1032) (#1036)',
    stats: '2 files changed, 14 insertions(+), 1 deletion(-)',
  },
  {
    sha: '43fe9f66',
    pr: 1026,
    title: 'Studio-pc mag een tag als event op zijn eigen video zetten (events_create) (#1026)',
    author: 'provispo',
    date: '2026-11-01T11:33:22+01:00',
    subject: 'Studio-pc mag een tag als event op zijn eigen video zetten (events_create) (#1026)',
    stats: '2 files changed, 33 insertions(+)',
  },
];
